import React from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface FavoriteButtonProps {
  isFavorite: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  isFavorite,
  onClick,
  size = "md",
  className,
}) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  const iconSizes = {
    sm: "w-3.5 h-3.5",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      className={cn(
        "flex items-center justify-center rounded-full transition-all duration-200",
        isFavorite
          ? "bg-amber-500 text-white shadow-lg shadow-amber-500/30"
          : "bg-white/60 text-muted-foreground hover:bg-amber-100 hover:text-amber-500",
        sizeClasses[size],
        className
      )}
      title={isFavorite ? "Remove from favorites" : "Add to favorites"}
    >
      <Star
        className={cn(
          iconSizes[size],
          "transition-all",
          isFavorite && "fill-white"
        )}
      />
    </button>
  );
};

export default FavoriteButton;
